import React, { Component } from 'react';
import './KPILevel.css';
import classNames from 'classnames';
import { getKPIColors } from '../../_utils/kpi';


interface Props {
    kpi?:any
}
interface State{
}

const max_levels = 5;

export default class KPILevel extends Component<Props, State>{

    render() {
        let kpi_color = getKPIColors(this.props.kpi?.level)
        return (
            <div className={classNames({
                "kpi-level": true,
            })}>
                <div className="kpi-level-value">
                   { this.props.kpi?.level ? <> Level {this.props.kpi?.level} </> : <div className="no-level">None</div> }
                </div>
                <div 
                    className="kpi-level-fill"
                    style={{
                        backgroundColor: kpi_color ? kpi_color[1] : undefined,
                        height: `${100 - (100/5) * (this.props.kpi?.level - 1)}%`
                    }}
                />
            </div>
        )
    }

};
